﻿export abstract class BaseResolver {
    public id: string;
    public component: React.ReactNode | null = null;
    public resolveOrder: number = 0;

    public abstract needResolution(): boolean;
    public abstract resolveSvg(svgContainer: HTMLTemplateElement);
}